// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { withRouter } from 'react-router-dom';
import workOrderStatusControl from '../../../utils/workOrderStatusControl';
const WorkOrderDetailsButtonControl = ({
  currentWorkOrder,
  history,
  deleteWorkOrderDetails,
  editOnHoldStatusWorkOrder,
  toggleModal,
  fetchApplicantsForWorkOrder,
  createWorkOrderTemplateByWorkOrder,
}) => {
  const workOrderControlButtonAvailable = workOrderStatusControl(currentWorkOrder.status);

  const handlerCreateTemplate = () => {
    const saveCopy = name => {
      createWorkOrderTemplateByWorkOrder(name, currentWorkOrder._id);
    };
    toggleModal(true, 'confirmModal', true, {
      onAccept: saveCopy,
      header: 'Create template by Work Order',
      inputLabel: 'Name',
      buttonLabels: { reject: 'Cancel' },
    });
  };

  const editWorkOrder = () => {
    toggleModal(false, 'viewDetailsWorkOrderModal');
    history.push(`/create-work-order/${currentWorkOrder._id}`);
  };

  const deleteWorkOrder = () => {
    deleteWorkOrderDetails({ workOrdersId: [currentWorkOrder._id] }, history);
  };

  const handlerOnHoldStatusChange = () => {
    editOnHoldStatusWorkOrder({
      workOrdersId: [currentWorkOrder._id],
      onHold: !currentWorkOrder.onHold,
    });
  };

  return (
    < >
      {
        !workOrderControlButtonAvailable.canceled
        && (
          <li>

            <button
              color="secondary"
              className="primary_btn"
              onClick={() => {
                fetchApplicantsForWorkOrder(currentWorkOrder._id);
                toggleModal(false, 'viewDetailsWorkOrderModal', true);
                toggleModal(true, 'viewAllApplicantsForWorkOrderModal', true, {
                  fromWorkOrderDetails: true,
                });
              }}
            >
              Applicants
            </button>
          </li>

        )
      }
      {
        workOrderControlButtonAvailable.beforeAssigned && !workOrderControlButtonAvailable.canceled
        && (
          <li>

            <button
              color="info"
              className="primary_btn"
              onClick={() => {
                toggleModal(true, 'nearByContractorModal', true);
              }}
            >
              Invite
            </button>
          </li>

        )
      }
      {
        workOrderControlButtonAvailable.workUncompleted && !workOrderControlButtonAvailable.canceled
        && <li>

          <button color="info" className="primary_btn" onClick={editWorkOrder}>Edit</button>
        </li>

      }
      {
        workOrderControlButtonAvailable.beforeAssigned && !workOrderControlButtonAvailable.canceled
        && <li>

          <button color="deep-orange" className="primary_btn" onClick={deleteWorkOrder}>Delete</button>
        </li>

      }
      {
        workOrderControlButtonAvailable.assigned
        && (
          <>
            <li>

              <button
                color="deep-orange"
                className="primary_btn"
                onClick={handlerOnHoldStatusChange}
              >
                {`${currentWorkOrder.onHold ? 'Remove' : ''} On Hold`}

              </button>
            </li>
            <li>
              <button
                color="deep-orange"
                className="primary_btn"
                onClick={() => toggleModal(true, 'explanationInputModal', true, 'cancel')}
              >
                Cancel
              </button>
            </li>
          </>
        )
      }
      <li>

        <button
          className="primary_btn"
          color="secondary"
          onClick={() => {
            toggleModal(true, 'copyWorkOrderModal', true, { workOrderId: currentWorkOrder._id });
          }}
        >
          Copy
        </button>
      </li>

      <li>

        <button
          className="primary_btn"
          color="info"
          onClick={handlerCreateTemplate}
        >
          Create Template
        </button>
      </li>

    </>
  );
};

export default withRouter(WorkOrderDetailsButtonControl);